// extracted by mini-css-extract-plugin
export default {"structuredDataCards":"StructuredData_structuredDataCards__e77CQ"};